export default __webpack_public_path__ + "static/accents-mixing-colors-do-light-a471a2bd531b6952001e4d5ac8f4cc2175ae95fc1358168833899c93a262a429.png";